













import { Component, Vue, Prop } from 'vue-property-decorator';
import { mdbBtn, mdbTooltip } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbBtn,
        mdbTooltip
    }
})
export default class AppSysBar extends Vue {
    @Prop() private overrideBackTo!: string;
    private backPage(): void {
        let urlToGoBackTo = this.$route.query.returnUrl ? this.$route.query.returnUrl.toString() : '';
        if (typeof this.overrideBackTo !== 'undefined') {
            urlToGoBackTo = this.overrideBackTo;
        }
        urlToGoBackTo ? this.$router.push(urlToGoBackTo) : this.$router.back();
    }
    private reloadPage(): void {
        location.reload(true);
    }
}
